import AppContent from '@components/App/appContent';
import PageContentWrapper from '@components/App/PageComponents/pageContentWrapper';
import { withStyles } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import AdminSettingsDrawer from '../../../components/App/Drawers/adminSettingsDrawer';


const styles = theme => ({
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
        align: 'center'
    },
    spinner: {
        textAlign: 'center',
        paddingTop: 16
    },
    paper: {
        padding: 16
    },
    paperStyle: {
        marginBottom: 40
    },
    listStyle: {
        paddingTop: 0,
        paddingBottom: 0
    },
    button: {
        margin: 16
    }
})

class Ashtrom extends React.Component {

    componentDidMount() {
        // this.loadData();
        this.props.adminService.getDashboardToken().then((res) => {            

            window.Cumulio.addDashboard({
                dashboardId: 'e830fa28-790d-432d-808e-c5adf921c722',
                container: '#my-dashboard',
                key: res.id,
                token: res.token,
                language: 'en'
            });
        })
    }

    render() {
        return <AppContent >
            <PageContentWrapper isFull={true} drawer={<AdminSettingsDrawer selected="time_tracking" />}>
                {/* {this.props.token ? <iframe style={{ border: 'none' }} src={"/graph/index.html?token=" + this.props.token} width="100%" height="1500px" /> : <div data-intrcm-id="ashtrom_leogxvj3" />} */}
                <div data-intrcm-id="ashtrom_8ezsqeff" id={"my-dashboard"}>

                </div>
            </PageContentWrapper>
        </AppContent>;
    }
}
const mapStateToProps = (state) => ({
    ...state.services,
    templates: state.globalData.templates,
    token: state.userData.idToken,

})


const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch
    }
}

export default compose(withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(Ashtrom);